import styled from "styled-components"

export const TreeSelectStyled = styled.div`
  .ant-select-selector {
    /* border: unset !important; */
    box-shadow: unset !important;
  }
  .ant-select-tree-switcher {
    .ant-select-tree-switcher-icon {
      height: 100%;
      svg {
        width: 8px !important;
        height: 8px !important;
      }
    }
  }
`
